import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../_actions/employeeLeave.actions'
import * as branchActions from '../_actions/branch.actions'
import * as departmentActions from '../_actions/department.actions'
import * as employeeActions from '../_actions/employee.actions'
import * as actionTypeActions from '../_actions/actiontype.actions'
import * as payrollDefaultWorkHourActions from '../_actions/payrollDefaultWorkHour.actions'
import * as payrollNormalWorkHourActions from '../_actions/payrollNormalWorkHour.actions'
import * as colorsCustomizationActions from '../_actions/customization/colors.actions'
import { Tabs } from 'antd'
import Rostering from '../components/roster/Rostering'
import WorkViewRoster from '../components/roster/WorkViewRoster'
import AbsenceViewRoster from '../components/roster/AbsenceViewRoster'
import Reporting from '../components/reporting/Reporting'
import CustomSpinner from '../components/common/CustomSpinner'
import Settings from '../components/settings/Settings'
import { isThisISOWeek } from 'date-fns'
const moment = require("moment");

class LeaveContainers extends React.Component {
    state = {
        activeTab: '1',
    }
    componentDidMount() {

        let _start = moment().startOf("month");
        let _end = moment().endOf("month");

        const query = {
            start: _start,
            end: _end
        }


        if (this.props.actionTypes.length == 0) {
            this.props.actions.actionTypeActions.fetchActionTypes()
        }

        // this.props.actions.employeeActions.fetchEmployeeList()
        
        

        // this.props.actions.payrollDefaultWorkHourActions.fetchPayrollDefaultWorkHours(query)
        // this.props.actions.payrollNormalWorkHourActions.fetchPayrollNormalWorkHours(query)

        this.props.actions.branchActions.fetchBranchList()
        this.props.actions.departmentActions.fetchDepartmentList()

        this.props.actions.colorsCustomizationActions.getColors()

        this.props.actions.leaveActions.fetchEmployeeLeave()
    }

    // toggle = tab => {
    //     if (this.state.activeTab !== tab) {
    //         this.setState({
    //             activeTab: tab,
    //         })
    //     }
    // }

    onChange = key => {
        this.setState({
            activeTab: key,
        })
        this.props.actions.leaveActions.fetchEmployeeLeave()
    }

    render() {
        return (
            <div className="container">
                <div className="content-heading clearfix">
                    {/* <div className="CPlogo" /> */}
                    <div className="heading-left">
                        <h1 className="page-title" style={{ fontSize: '1.25rem' }}>Leave Calendar</h1>
                        {/* <p className="page-subtitle">
                            Rostering, manage employee work, absence
                        </p> */}
                    </div>
                </div>

                <Rostering actions={this.props.actions} />

            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loading: state.roster.loadingEvents,
        loadingColors: state.colors.loading,
        events: state.roster.events,
        employees: state.roster.employeeList,
        actionTypes: state.ActionTypesReducer.actionTypes,
        payrollDefaultWorkHour: state.payrollDefaultWorkHour,
        payrollNormalWorkHour: state.payrollNormalWorkHour,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            leaveActions: bindActionCreators(instructorActions, dispatch),
            branchActions: bindActionCreators(branchActions, dispatch),
            departmentActions: bindActionCreators(departmentActions, dispatch),
            employeeActions: bindActionCreators(employeeActions, dispatch),
            actionTypeActions: bindActionCreators(actionTypeActions, dispatch),
            payrollDefaultWorkHourActions: bindActionCreators(
                payrollDefaultWorkHourActions,
                dispatch
            ),
            payrollNormalWorkHourActions: bindActionCreators(
                payrollNormalWorkHourActions,
                dispatch
            ),
            colorsCustomizationActions: bindActionCreators(
                colorsCustomizationActions,
                dispatch
            ),
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaveContainers)
